import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_PAGE_LIMIT,
  diamQueryKeys,
  getTeamsPage,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import { TEAMS_LIST_FILTER } from '../TeamsGrid/useTeams';
import type { InviteTeamOption } from './types';

export function useInviteTeamOptions(enabled: boolean) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  const teamsQuery = useQuery({
    queryKey: [
      ...diamQueryKeys.teams(TEAMS_LIST_FILTER),
      'invite-modal',
    ] as const,
    queryFn: async () => {
      const idToken = await getIdToken();
      return getTeamsPage(apiUrl, idToken, {
        page: 0,
        limit: DIAM_PAGE_LIMIT,
        filter: TEAMS_LIST_FILTER,
      });
    },
    enabled: isSignedIn && enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });

  const teamOptions = useMemo<InviteTeamOption[]>(
    () =>
      (teamsQuery.data?.elements ?? [])
        .map(team => ({
          id: team.id,
          name: team.name,
        }))
        .sort((left, right) => left.name.localeCompare(right.name)),
    [teamsQuery.data],
  );

  return {
    teamOptions,
    isLoading: teamsQuery.isLoading,
    isError: teamsQuery.isError,
    error: teamsQuery.error,
  };
}
